export const solarPowerTran: any = {
    eu: {
        a_name_1: 'Hair Dryer',
        a_name_2: 'Electric Kettle',
        a_name_3: 'Washing Machine',
        a_name_4: 'Microwave Oven',
        a_name_5: 'Toaster',
        a_name_6: 'Vacuum Cleaner',
        a_name_7: 'Coffee Maker',
        a_name_8: 'Blender',
        a_name_9: 'Juicer',
        a_name_10: 'Wi‑Fi Router',
        a_name_11: 'Phone Charger',
        a_name_12: 'Laptop',
        b_name_1: 'Microwave Oven',
        b_name_2: 'Toaster',
        b_name_3: 'Vacuum Cleaner',
        b_name_4: 'Coffee Maker',
        b_name_5: 'Blender',
        b_name_6: 'Juicer',
        b_name_7: 'Wi‑Fi Router',
        b_name_8: 'Phone Charger',
        b_name_9: 'Laptop',
        c_name_1: 'Coffee Maker',
        c_name_2: 'Blender',
        c_name_3: 'Juicer',
        c_name_4: 'Wi‑Fi Router',
        c_name_5: 'Phone Charger',
        c_name_6: 'Laptop',
        d_name_1: 'Wi‑Fi Router',
        d_name_2: 'Phone Charger',
        d_name_3: 'Laptop',
        a_notes: "Note: Appliances should be plugged into the battery's AC outlet. Please refer to the rating label on each device for actual power usage.",
        b_notes: "Note: Appliances should be plugged into the battery's AC outlet. Please refer to the rating label on each device for actual power usage.",
        c_notes: "Note: Appliances should be plugged into the battery's AC outlet. Please refer to the rating label on each device for actual power usage.",
        d_notes: "Note: Please refer to each appliance's rating label for actual power usage.",
    },
    uk: {
        a_name_1: 'Hair Dryer',
        a_name_2: 'Electric Kettle',
        a_name_3: 'Washing Machine',
        a_name_4: 'Microwave Oven',
        a_name_5: 'Toaster',
        a_name_6: 'Vacuum Cleaner',
        a_name_7: 'Coffee Maker',
        a_name_8: 'Blender',
        a_name_9: 'Juicer',
        a_name_10: 'Wi‑Fi Router',
        a_name_11: 'Phone Charger',
        a_name_12: 'Laptop',
        b_name_1: 'Microwave Oven',
        b_name_2: 'Toaster',
        b_name_3: 'Vacuum Cleaner',
        b_name_4: 'Coffee Maker',
        b_name_5: 'Blender',
        b_name_6: 'Juicer',
        b_name_7: 'Wi‑Fi Router',
        b_name_8: 'Phone Charger',
        b_name_9: 'Laptop',
        c_name_1: 'Coffee Maker',
        c_name_2: 'Blender',
        c_name_3: 'Juicer',
        c_name_4: 'Wi‑Fi Router',
        c_name_5: 'Phone Charger',
        c_name_6: 'Laptop',
        d_name_1: 'Wi‑Fi Router',
        d_name_2: 'Phone Charger',
        d_name_3: 'Laptop',
        a_notes: 'Note: Appliances must connect to the battery’s AC outlet. Check each device’s rating label for actual power usage.',
        b_notes: 'Note: Appliances must connect to the battery’s AC outlet. Check each device’s rating label for actual power usage.',
        c_notes: 'Note: Appliances must connect to the battery’s AC outlet. Check each device’s rating label for actual power usage.',
        d_notes: "Note: Please refer to each appliance's rating label for actual power usage.",
    },
    de: {
        a_name_1: 'Haartrockner',
        a_name_2: 'Wasserkocher',
        a_name_3: 'Waschmaschine',
        a_name_4: 'Mikrowelle',
        a_name_5: 'Toaster',
        a_name_6: 'Staubsauger',
        a_name_7: 'Kaffeemaschine',
        a_name_8: 'Mixer',
        a_name_9: 'Entsafter',
        a_name_10: 'WLAN Router',
        a_name_11: 'Handy-Ladegerät',
        a_name_12: 'Laptop',
        b_name_1: 'Mikrowelle',
        b_name_2: 'Toaster',
        b_name_3: 'Staubsauger',
        b_name_4: 'Kaffeemaschine',
        b_name_5: 'Mixer',
        b_name_6: 'Entsafter',
        b_name_7: 'WLAN Router',
        b_name_8: 'Handy-Ladegerät',
        b_name_9: 'Laptop',
        c_name_1: 'Kaffeemaschine',
        c_name_2: 'Mixer',
        c_name_3: 'Entsafter',
        c_name_4: 'WLAN Router',
        c_name_5: 'Handy-Ladegerät',
        c_name_6: 'Laptop',
        d_name_1: 'WLAN Router',
        d_name_2: 'Handy-Ladegerät',
        d_name_3: 'Laptop',
        a_notes:
            'Hinweis: Bitte schließen Sie Geräte immer an die AC-Steckdose der Batterie an. Die tatsächliche Leistungsaufnahme entnehmen Sie bitte dem Typenschild des jeweiligen Geräts.',
        b_notes:
            'Hinweis: Bitte schließen Sie Geräte immer an die AC-Steckdose der Batterie an. Die tatsächliche Leistungsaufnahme entnehmen Sie bitte dem Typenschild des jeweiligen Geräts.',
        c_notes:
            'Hinweis: Bitte schließen Sie Geräte immer an die AC-Steckdose der Batterie an. Die tatsächliche Leistungsaufnahme entnehmen Sie bitte dem Typenschild des jeweiligen Geräts.',
        d_notes: 'Hinweis: Den tatsächlichen Stromverbrauch entnehmen Sie bitte dem Typenschild des jeweiligen Geräts.',
    },
    fr: {
        a_name_1: 'Sèche-cheveux',
        a_name_2: 'Bouilloire électrique',
        a_name_3: 'Machine à laver',
        a_name_4: 'Four à micro-ondes',
        a_name_5: 'Grille pain',
        a_name_6: 'Aspirateur',
        a_name_7: 'Cafetière',
        a_name_8: 'Mixeur',
        a_name_9: 'Extracteur de jus',
        a_name_10: 'Routeur Wi-Fi',
        a_name_11: 'Chargeur de téléphone',
        a_name_12: 'Ordinateur portable',
        b_name_1: 'Four à micro-ondes',
        b_name_2: 'Grille pain',
        b_name_3: 'Aspirateur',
        b_name_4: 'Cafetière',
        b_name_5: 'Mixeur',
        b_name_6: 'Extracteur de jus',
        b_name_7: 'Routeur Wi-Fi',
        b_name_8: 'Chargeur de téléphone',
        b_name_9: 'Ordinateur portable',
        c_name_1: 'Cafetière',
        c_name_2: 'Mixeur',
        c_name_3: 'Extracteur de jus',
        c_name_4: 'Routeur Wi-Fi',
        c_name_5: 'Chargeur de téléphone',
        c_name_6: 'Ordinateur portable',
        d_name_1: 'Routeur Wi-Fi',
        d_name_2: 'Chargeur de téléphone',
        d_name_3: 'Ordinateur portable',
        a_notes:
            "Remarque : les appareils doivent être branchés sur la prise CA de la batterie. Veuillez vous référer à l'étiquette d'évaluation sur chaque appareil pour la consommation électrique réelle.",
        b_notes:
            "Remarque : les appareils doivent être branchés sur la prise CA de la batterie. Veuillez vous référer à l'étiquette d'évaluation sur chaque appareil pour la consommation électrique réelle.",
        c_notes:
            "Remarque : les appareils doivent être branchés sur la prise CA de la batterie. Veuillez vous référer à l'étiquette d'évaluation sur chaque appareil pour la consommation électrique réelle.",
        d_notes: "Remarque : Veuillez vous référer à l'étiquette d'évaluation de chaque appareil pour la consommation électrique réelle.",
    },
    it: {
        a_name_1: 'Asciugacapelli',
        a_name_2: 'Bollitore elettrico',
        a_name_3: 'Lavatrice',
        a_name_4: 'Forno a microonde',
        a_name_5: 'Tostapane',
        a_name_6: 'Aspirapolvere',
        a_name_7: 'Macchina per il caffè',
        a_name_8: 'Frullatore',
        a_name_9: 'Spremiagrumi',
        a_name_10: 'Router Wi-Fi',
        a_name_11: 'Caricabatterie del telefono',
        a_name_12: 'Computer portatile',
        b_name_1: 'Forno a microonde',
        b_name_2: 'Tostapane',
        b_name_3: 'Aspirapolvere',
        b_name_4: 'Macchina per il caffè',
        b_name_5: 'Frullatore',
        b_name_6: 'Spremiagrumi',
        b_name_7: 'Router Wi-Fi',
        b_name_8: 'Caricabatterie del telefono',
        b_name_9: 'Computer portatile',
        c_name_1: 'Macchina per il caffè',
        c_name_2: 'Frullatore',
        c_name_3: 'Spremiagrumi',
        c_name_4: 'Router Wi-Fi',
        c_name_5: 'Caricabatterie del telefono',
        c_name_6: 'Computer portatile',
        d_name_1: 'Router Wi-Fi',
        d_name_2: 'Caricabatterie del telefono',
        d_name_3: 'Computer portatile',
        a_notes:
            'Nota: gli apparecchi devono essere collegati alla presa CA della batteria. Consulta l’etichetta energetica del singolo dispositivo per conoscere i dati sul consumo energetico effettivo.',
        b_notes:
            'Nota: gli apparecchi devono essere collegati alla presa CA della batteria. Consulta l’etichetta energetica del singolo dispositivo per conoscere i dati sul consumo energetico effettivo.',
        c_notes:
            'Nota: gli apparecchi devono essere collegati alla presa CA della batteria. Consulta l’etichetta energetica del singolo dispositivo per conoscere i dati sul consumo energetico effettivo.',
        d_notes: 'Nota: consulta l’etichetta energetica dei singoli apparecchi per conoscere i dati sul consumo energetico effettivo.',
    },
    es: {
        a_name_1: 'Secador de pelo',
        a_name_2: 'Hervidor eléctrico',
        a_name_3: 'Lavadora',
        a_name_4: 'Horno microondas',
        a_name_5: 'Tostadora',
        a_name_6: 'Aspiradora',
        a_name_7: 'Cafetera',
        a_name_8: 'Licuadora',
        a_name_9: 'Exprimidor',
        a_name_10: 'Router Wi-Fi',
        a_name_11: 'Cargador de teléfono',
        a_name_12: 'Ordenador portátil',
        b_name_1: 'Horno microondas',
        b_name_2: 'Tostadora',
        b_name_3: 'Aspiradora',
        b_name_4: 'Cafetera',
        b_name_5: 'Licuadora',
        b_name_6: 'Exprimidor',
        b_name_7: 'Router Wi-Fi',
        b_name_8: 'Cargador de teléfono',
        b_name_9: 'Ordenador portátil',
        c_name_1: 'Cafetera',
        c_name_2: 'Licuadora',
        c_name_3: 'Exprimidor',
        c_name_4: 'Router Wi-Fi',
        c_name_5: 'Cargador de teléfono',
        c_name_6: 'Ordenador portátil',
        d_name_1: 'Router Wi-Fi',
        d_name_2: 'Cargador de teléfono',
        d_name_3: 'Ordenador portátil',
        a_notes:
            'Nota: Los electrodomésticos deben enchufarse a la toma CA de la batería. Consulta la etiqueta de clasificación de cada dispositivo para el uso real de energía.',
        b_notes:
            'Nota: Los electrodomésticos deben enchufarse a la toma CA de la batería. Consulta la etiqueta de clasificación de cada dispositivo para el uso real de energía.',
        c_notes:
            'Nota: Los electrodomésticos deben enchufarse a la toma CA de la batería. Consulta la etiqueta de clasificación de cada dispositivo para el uso real de energía.',
        d_notes: 'Nota: Consulta la etiqueta de clasificación de cada electrodoméstico para el uso real de energía.',
    },
};
